export default __webpack_public_path__ + "static/waves-b1a4ad08daaed8f3c5023f872089f27d.svg";